<template>
  <mission-detail-file-upload :filterCurrentMission="false" />
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import MissionDetailFileUpload from '@/components/mission/MissionDetailFileUpload.vue'


@Component({
  name: 'UploadFile',   
  components:{MissionDetailFileUpload}
})
export default class Fiche extends Vue {    

}
</script>